<template>
    <div>
        <el-row>
            <el-col>
                <el-form ref="form" :model="addData" label-width="90px" style="text-align: left">
                    <el-form-item label="具体路径" prop="path">
                        <el-input clearable size="medium" placeholder="请输入具体路径" v-model="addData.link">
                          <el-button type="primary" slot="append" @click="select">确认</el-button>
                        </el-input>
                        <div class="memo">如需跳转的到具体页面，请填写页面具体路径</div>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

    </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        addData: {
          link: '',
          title: '自定义',
        },
        host: ''
      }
    },
    watch: {},
    created() {
      this.host = location.host;
    },
    methods: {
      select() {
        if(!this.addData.link){
          this.$message.error("请填写跳转路径!");
          return;
        }
        this.$emit('select',this.addData);
      }
    }
  }
</script>

<style lang="sass">
</style>